import styled from "styled-components";
import {
  Button as AntButton,
  Form as AntForm,
  Input as AntInput,
} from 'antd';
import { AuthLogo } from "@assets/auth";

export const RootContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(156deg, #FFEBC6 13%, #D8A011 84.84%);

  align-items: center;

  .ant-btn-primary {
    width: 100%;
    height: 56px;
    color: #FFF;
  }

  position: relative;
`;

export const Heading = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: baseline;
  align-items: center;
`

export const NavContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  width: calc(100%);
  padding: 0 16px;
  flex-direction: row;
  justify-content: ${props => props.backKey ? 'end' : 'space-between'};
  align-items: center;
  height: 37px;/* need to add this to be the same height with nav from other auth pages */
  margin: 16px 0 0 0;
`;

export const ArrowIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background: linear-gradient(133deg, #FFD648 -3.8%, #AA5E1B 100%);
  cursor: pointer;
  padding: 8px;
`
export const BackButton = styled.div`
  padding: 8px 26px;
  color: #FFF;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;

export const SkipButton = styled(AntButton)`
  padding: 12px 27px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 36px;
  border-radius: 100px;
  background: rgba(0, 0, 0, 0.50);
  /* text-transform: uppercase; */

  color: #FFF;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
`

export const Logo = styled(AuthLogo)`
  margin: -5px auto 10px auto;
  width: 224px;
  height: 96px;
`
export const Title = styled.div`
  color: #2A2A2A;
  text-align: center;
  font-size: 18px !important;
  font-style: normal;
  font-weight: 700;
  line-height: 30px; /* 150% */
  margin: 24px 0 0 0;
`

export const ContentContainer = styled.div`
  width: calc(100% - 32px);
  margin: 0 auto 24px;
  padding: 0 16px 0;
  box-sizing: border-box;

  border-radius: 16px;
  background: #FFF;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.10);
`

export const Form = styled(AntForm)`
  margin: 24px 0 0 0;
  width: 100%;
  text-align: center;

  .ant-form-item-explain {
    text-align: left; /* align warning text to the left */
    margin-left: 8px;
  }

  .ant-form-item-label {
    text-align: left;
    padding: 0 !important;
  }

  .ant-form-item-label label {
    color: #2A2A2A !important;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 171.429% */

    margin: 0px 0px 4px 0px !important;
  }

`;
export const Input = styled(AntInput)`
  -moz-appearance: textfield;
;
  padding-left: 13px;
  height: 55px;
  border-radius: 12px;
  background: #FFF !important;

  color: #000 !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;

  &::placeholder {
    color: #9F9F9F !important;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  appearance: textfield;
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none; /* WebKit */
    margin: 0;
  }
  ::-webkit-inner-spin-button:disabled,
  ::-webkit-outer-spin-button:disabled {
    display: none;
  }
`;

export const TextButton = styled(AntButton)`
  margin: -22px 0 16px;

  color: #D66700;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; /* 162.5% */

  &:hover{
    color: #D66700 !important;
  }
`

export const ORText = styled.div`
  margin: 24px auto !important;

  color: #2A2A2A;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; /* 162.5% */
`

export const ORTextForRegister = styled(ORText)`
  margin: 16px auto !important;
`

export const LoginButton = styled(AntButton)`
  margin: 0px 0 0 0;
  width: 100%;
  height: 55px !important;
`

export const RegisterButton = styled(AntButton)`
  margin: 0 0 16px;
  border-radius: 8px;
  border: 1px solid #D66700 !important;
  background: #D66700 !important;
  width: calc(100% - 32px);
  box-sizing: border-box;
  height: 52px;

  color: #FFF !important;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;

  &:hover {
    color: #FFF !important;
    background: #D66700 !important;
  }
`

export const GoToPromoRegisterButton = styled(RegisterButton)`
`

export const ContinueButton = styled(AntButton)`
`;

export const GoToLogin = styled(RegisterButton)`

`


export const TelegramLoginButton = styled.div`
margin: 0 20px 0 20px;
width: calc(100% - 40px);
height: 52px;
border-radius: 8px;
display: flex;
gap: 10px;
align-items: center;
justify-content: center;
background-color: #fff;
cursor: pointer;
position: relative;

font-size: 14px;
font-weight: bold;

svg {
  width: 24px;
}

.ant-spin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
`;


export const SocialLoginWrapper = styled.div`
display:flex;
width:100%;
gap:20px;
align-items:center;
margin-top:30px;
margin-bottom:30px;
`;

export const SpaceBetweenTopBottom = styled.div`
margin-top: 24px;
margin-bottom: 24px;
width:100%;
`;

export const SocialRegisterWrapper = styled.div`
display:flex;
width: calc(100% - 32px);
gap:20px;
align-items:center
`;

export const TelegramRegisterButton = styled.div`
margin-top: 24px;
margin-bottom: 24px;
width: 100%;
height: 52px;
border-radius: 8px;
display: flex;
gap: 10px;
align-items: center;
justify-content: center;
background: #fff;
border: 1px solid #d66700;
cursor: pointer;
position: relative;

font-size: 14px;
font-weight: bold;
color: #d66700;

svg {
  width: 24px;
}

.ant-spin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
`;